import { trace } from 'rytm-helpers'
import { Modal } from 'bootstrap'


export const initModvideo = () => {
  document.addEventListener("click", onDocClick)
}

const onDocClick = (e) => {
  if (e.target.classList.contains("video-trigger")) {
    e.preventDefault()
    const url = e.target.dataset.url
    const selector = e.target.dataset.selector
    const wrapper = selector ? document.querySelector(selector) : null
    if (url && wrapper) {
      if (!e.target.classList.contains("loading")) {
        e.target.classList.add('loading')
        // ajax request
        let xhr = new XMLHttpRequest()
        xhr.dcWrapper = wrapper
        // add event listeners
        xhr.addEventListener('loadstart', onXhrLoadStart);
        xhr.addEventListener('load', onXhrLoad);
        xhr.addEventListener('loadend', onXhrLoadEnd);
        xhr.addEventListener('progress', onXhrProgress);
        xhr.addEventListener('error', onXhrError);
        xhr.addEventListener('abort', onXhrAbord);
        xhr.open('GET', url)
        xhr.send()
      } else {
        openModal(wrapper)
      }
    }
  }
}


const openModal = (wrapper) => {
  const modalEl = wrapper.querySelector(".modal")
  if (modalEl) {
    const modal = new Modal(modalEl)
    modal.show()
  }
}
/**
 * ######################
 * # XHR Event handlers #
 */
// # XHR Start
const onXhrLoadStart = (e) => {
  // dispatch event
  document.documentElement.classList.add("content-loading")
}
// # XHR Load
const onXhrLoad = (e) => {
  // 
}
// # XHR Complete
const onXhrLoadEnd = (e) => {
  const dcWrapper = e.target.dcWrapper
  dcWrapper.innerHTML = e.target.responseText
  document.documentElement.classList.remove("content-loading")
  openModal(dcWrapper)
}
// # XHR Progress
const onXhrProgress = (e) => {
  // console.log("progress", e)
}
// # XHR Error
const onXhrError = (e) => {
  document.documentElement.classList.remove("content-loading")
}
// # XHR Abord
const onXhrAbord = (e) => {
  document.documentElement.classList.remove("content-loading")
}